module.exports = __webpack_public_path__ + "img/three2Orange.2b024a89.jpg";